import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DataInsightState } from './data-insight.reducer';




export const dataInsightStoreProperty = 'data-insights';


export const selectDataInsightState = createFeatureSelector<DataInsightState>(dataInsightStoreProperty);
export const selectDataInsight = createSelector(
    selectDataInsightState,
    (state) => state.dataInsights
  );